<action-box *ngIf="visible" textLeft="{{actionBoxTitle}}" [showHeader]="showHeader">
  
    <panel-codes-builder [valuesModel]="valuesModel" [showInlineTitle]="false" ></panel-codes-builder>

</action-box>
